import "../../functions/AcordionList";
$(function(){
    $('#INDEX-02-0001').find('.pg-p-text__section-title--charcter-line').each(function(){
        $(this).on('click',function(){
        	$(this).toggleClass('on');
            $("+.pg-p-ward-store-list",this).slideToggle();
            return false;
        });
    });
});